import React from 'react';
import { 
  Box, 
  Flex, 
  Text, 
  Link, 
  VStack, 
  HStack,
  Divider,
  Image,
  useColorMode
} from '@chakra-ui/react';
import { FaInstagram, FaFacebook, FaEnvelope, FaPhone } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';
import {
  OWNER_NAME,
  ICO,
  BUSINESS_ADDRESS,
  REGISTRATION_NOTE,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_HREF,
} from '../data/business';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { colorMode } = useColorMode();

  return (
    <Box 
      as="footer" 
      className="footer-container"
      bg={colorMode === 'dark' ? 'gray.900' : 'black'} // Footer is typically dark in both modes
    >
      <Box className="footer-content">
        <Flex className="footer-main">
          {/* Logo and About Section */}
          <VStack className="footer-section footer-about" align="start">
            <Image 
              src="/photos/whiteLogo.png" 
              alt="Eva Kodytková Logo" 
              className="footer-logo"
            />
            <Text 
              className="footer-about-text"
              color={colorMode === 'dark' ? 'gray.300' : 'gray.300'} // Always light gray in footer
            >
              Fotografka z Orlických hor specializující se na portrétní, svatební a rodinnou fotografii. 
              Zachycuji autentické momenty vašeho života.
            </Text>
          </VStack>

          {/* Contact Information */}
          <VStack className="footer-section footer-contact" align="start">
            <Text 
              className="footer-heading"
              color={colorMode === 'dark' ? 'white' : 'white'} // Always white in footer
            >
              Kontakt
            </Text>
            <VStack align="start" spacing={3}>
              <HStack>
                <IconWrapper icon={FaEnvelope} />
                <Link 
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="footer-link"
                  color={colorMode === 'dark' ? 'gray.300' : 'gray.300'} // Always light gray in footer
                >
                  {CONTACT_EMAIL}
                </Link>
              </HStack>
              <HStack>
                <IconWrapper icon={FaPhone} />
                <Link 
                  href={CONTACT_PHONE_HREF}
                  className="footer-link"
                  color={colorMode === 'dark' ? 'gray.300' : 'gray.300'} // Always light gray in footer
                >
                  {CONTACT_PHONE}
                </Link>
              </HStack>
              {/* <HStack>
                <IconWrapper icon={FaMapMarkerAlt} />
                <Text 
                  className="footer-text"
                  color={colorMode === 'dark' ? 'gray.300' : 'gray.300'} // Always light gray in footer
                >
                  Orlické hory, Česká republika
                </Text>
              </HStack> */}
            </VStack>
          </VStack>

          {/* Services */}
          <VStack className="footer-section footer-services" align="start">
            <Text className="footer-heading">Služby</Text>
            <VStack align="start" spacing={2}>
              <Link href="#portfolio" className="footer-link">Rodinné focení</Link>
              <Link href="#portfolio" className="footer-link">Párové focení</Link>
              <Link href="#portfolio" className="footer-link">Portrétní focení</Link>
              <Link href="#portfolio" className="footer-link">Svatební focení</Link>
            </VStack>
          </VStack>

          {/* Social Media */}
          <VStack className="footer-section footer-social" align="start">
            <Text className="footer-heading">Sledujte mě</Text>
            <VStack align="start" spacing={3}>
              <HStack>
                <IconWrapper icon={FaInstagram} />
                <Link 
                  href="https://www.instagram.com/hrachovenachova/" 
                  isExternal 
                  className="footer-link"
                >
                  @hrachovenachova
                </Link>
              </HStack>
              <HStack>
                <IconWrapper icon={FaFacebook} />
                <Link 
                  href="https://www.facebook.com/hrachovenachova" 
                  isExternal 
                  className="footer-link"
                >
                  Eva Kodytková Photography
                </Link>
              </HStack>
            </VStack>
            <Text className="footer-cta">
              Podělte se o svou inspiraci a nechte se inspirovat!
            </Text>
          </VStack>
        </Flex>

        <Divider className="footer-divider" />

        {/* Copyright Section */}
        <Flex className="footer-bottom">
          {/* IČO, místo podnikání a údaj o zápisu jen když je Eva doplní
              (src/data/business.ts) */}
          <Box className="footer-legal">
            <Text className="footer-copyright">
              © {currentYear} {OWNER_NAME}. Všechna práva vyhrazena.
              {ICO && <> · IČO {ICO}</>}
              {BUSINESS_ADDRESS && <> · {BUSINESS_ADDRESS}</>}
            </Text>
            {ICO && <Text className="footer-registration">{REGISTRATION_NOTE}</Text>}
          </Box>
          <Flex className="footer-bottom-links">
            <Link href="/privacy-policy" className="footer-bottom-link">Ochrana osobních údajů</Link>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;
